export class DaoCatalogs {
  get(country: string, slug: string): any {
    return new Promise((resolve, reject) => {
      const url =
        process.env.dataHost +
        '/catalogs/' +
        country.toLowerCase() +
        '/' +
        slug +
        '.json'

      fetch(url, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json()
          } else {
            reject(new Error('failed'))
          }
        })
        .then((data) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}
